module.exports = __webpack_public_path__ + "img/hong meiling_sc2.d1726b2e.png";